<template>
  <v-skeleton-loader
    class="rounded-pill"
    :height="height"
    width="112px"
    type="image"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "BaseSelectorLoading",
  // DATAs
  props: {
    buttonSize: {
      type: String,
      default: () => "medium"
    }
  },
  computed: {
    height() {
      switch (this.buttonSize) {
        case "medium":
          return "36px";
        case "x-small":
          return "20px";
        case "x-large":
          return "52px";
        case "small":
          return "28px";
        case "large":
          return "44px";
        default:
          return "36px";
      }
    }
  }
};
</script>
